import styled from 'styled-components';

/**
 * A square icon button that sits beside a compact field (a side panel's
 * search), sharing its box: `--field-h-sm` tall, `--radius-input`, the same
 * 1px border and the same resting → hover escalation, so the row reads as one
 * control strip (docs/design-system.md § "Field + icon action row").
 *
 * Always a real `<button>`: give it an `aria-label`. Its icon is 16px in
 * `currentColor`. The Photo tab's sort toggle was a styled `div`, 34px tall
 * beside a 28px field, unreachable by keyboard (PLAT-12136).
 */
const FieldIconButton = styled.button.attrs({ type: 'button' })`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--field-h-sm);
  height: var(--field-h-sm);
  padding: 0;
  border: 1px solid var(--input-border, var(--border));
  border-radius: var(--radius-input);
  background-color: var(--input-background, transparent);
  color: var(--text-muted);
  cursor: pointer;
  transition:
    border-color var(--transition-fast),
    color var(--transition-fast);

  &:hover:not(:disabled) {
    border-color: var(--text-muted);
    color: var(--foreground);
  }

  &:focus-visible {
    outline: none;
    border-color: var(--focus-border);
    box-shadow: 0 0 0 1px var(--focus-ring);
    color: var(--foreground);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export default FieldIconButton;
